/**
 * HeroImageCombined.jsx
 * Created by Tim on 12/20/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { find, toNumber } from 'lodash';
import axios from 'axios';

import HeroImageLowQuality from './HeroImageLowQuality';
import HeroImageUnavailable from './HeroImageUnavailable';
import HeroImage from './HeroImage';
import { Placeholder } from './Placeholder';
import Spinner from './Spinner';

const propTypes = {
    type: PropTypes.string,
    id: PropTypes.string,
    loadingType: PropTypes.string,
};

const defaultProps = {
    loadingType: 'spinner',
    type: 'asset',
    id: 0
};

const HERO_IMAGE_TYPES = {
    HERO_IMAGE: "heroImage",
    HERO_IMAGE_LOW_QUALITY: "heroImageLowQuality",
    HERO_IMAGE_UNDEFINED: "heroImageUndefined"
};

export default class HeroImageCombined extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            heroImage: "",
            altText: "",
            ariaLabel: "",
            type: HERO_IMAGE_TYPES.HERO_IMAGE_UNDEFINED,
            loaded: false
        };
    }

    componentDidMount() {
        this._mounted = true;
        this.loadMedia();
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    loadMedia = () => {
        axios.get(`/api/media/public/${this.props.type}/${this.props.id}`, {})
            .then((res) => {
                if (res && !res.data.err && res.data.result) {
                    const photos = res.data.result;

                    // Set the banner photo, if it exists
                    let bannerPhoto = find(photos, { is_primary: true });
                    if (bannerPhoto === undefined) {
                        bannerPhoto = null;
                    }

                    // Todo: Mike Bray - Add preview image if viewport width under 768px

                    if (!bannerPhoto && photos.length > 0) {
                        bannerPhoto = photos[0];
                    }

                    if (bannerPhoto) {
                        if (bannerPhoto.width && toNumber(bannerPhoto.width) >= 1240) {
                            if (this._mounted) {
                                this.setState({
                                    loaded: true,
                                    heroImage: bannerPhoto.url,
                                    ariaLabel: bannerPhoto.title,
                                    type: HERO_IMAGE_TYPES.HERO_IMAGE
                                });
                            }
                        }
                        else if (this._mounted) {
                            this.setState({
                                loaded: true,
                                heroImage: bannerPhoto.url,
                                altText: bannerPhoto.title,
                                ariaLabel: bannerPhoto.description ? bannerPhoto.description : bannerPhoto.title,
                                type: HERO_IMAGE_TYPES.HERO_IMAGE_LOW_QUALITY
                            });
                        }
                    }
                }
                else if (this._mounted) {
                    this.setState({
                        loaded: true
                    });
                }
            })
            .catch(() => {
                if (this._mounted) {
                    try {
                        this.setState({
                            loaded: true
                        });
                    }
                    catch (e) {
                        // During testing on jest after a test suite completes the `window.document`
                        // gets nullified and callig `setState` results on an error
                    }
                }
            })
    }

    render() {
        let heroImageComponent = this.props.loadingType === 'placeholder' ? (
            <div className="rec-image-loading-header-wrap">
                <Placeholder height="100%" />
            </div>
        ) : (
            <Spinner size="xl" />
        );

        if (this.state.type === HERO_IMAGE_TYPES.HERO_IMAGE) {
            heroImageComponent = (
                <HeroImage
                    heroImage={{ backgroundImage: `url(${this.state.heroImage})` }}
                    ariaLabel={this.state.ariaLabel} />
            );
        }
        else if (this.state.type === HERO_IMAGE_TYPES.HERO_IMAGE_LOW_QUALITY) {
            heroImageComponent = (
                <HeroImageLowQuality
                    image={this.state.heroImage}
                    altText={this.state.altText}
                    ariaLabel={this.state.ariaLabel} />
            );
        }
        else if (this.state.loaded) {
            heroImageComponent = (
                <div className="rec-image-unavailable-header-wrap">
                    <HeroImageUnavailable />
                </div>
            );
        }

        return heroImageComponent;
    }
}

HeroImageCombined.propTypes = propTypes;
HeroImageCombined.defaultProps = defaultProps;
